export const formPrimaryButtonSx = {
  marginTop: 2,
  minHeight: 44,
  borderRadius: 999,
  px: 3,
  fontWeight: 700,
  textTransform: 'none',
  letterSpacing: '0.02em',
  boxShadow: '0 10px 20px rgba(25, 118, 210, 0.28)',
  background: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 45%, #3b82f6 100%)',
  transition: 'transform 0.16s ease, box-shadow 0.16s ease, opacity 0.16s ease',
  '&:hover': {
    background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #2563eb 100%)',
    boxShadow: '0 12px 24px rgba(29, 78, 216, 0.34)',
    transform: 'translateY(-1px)',
  },
  '&:active': {
    transform: 'translateY(0)',
    boxShadow: '0 6px 14px rgba(29, 78, 216, 0.28)',
  },
  '&.Mui-disabled': {
    background: '#cbd5e1',
    color: '#64748b',
    boxShadow: 'none',
  },
};

export const formSecondaryButtonSx = {
  minHeight: 42,
  borderRadius: 999,
  px: 2.5,
  fontWeight: 700,
  textTransform: 'none',
  letterSpacing: '0.01em',
  boxShadow: '0 6px 14px rgba(30, 64, 175, 0.2)',
  background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
  '&:hover': {
    background: 'linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)',
    boxShadow: '0 8px 16px rgba(29, 78, 216, 0.24)',
  },
};
